// extracted by mini-css-extract-plugin
export default {"toggle":"EVAB","toggle__icon":"fn391"};